import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ViewPropertyDetails from "../../interface/Watchlist/propertyDetails";

interface IProprtyDetailsState {
  porpertyDetails: [ViewPropertyDetails];
  propertySummary: ViewPropertyDetails | null;
  showFileUploadNotes: boolean;
  error: string | null;
}

const initialState: IProprtyDetailsState = {
  porpertyDetails: [null],
  propertySummary: null,
  showFileUploadNotes: false,
  error: null,
};

const propertyDetailsSlice = createSlice({
  name: "propertyDetails",
  initialState,
  reducers: {
    setPropertyDetails(state, action: PayloadAction<IProprtyDetailsState>) {
      state.porpertyDetails.push(action.payload);
    },
    setPropertySummary(state, action: PayloadAction<ViewPropertyDetails>) {
      state.propertySummary = action.payload;
    },
    setShowFileUploadNotes(state, action: PayloadAction<boolean>) {
      state.showFileUploadNotes = action.payload;
    },
    cleartPropertyDetails(state) {
      state.porpertyDetails = [null];
    },
  },
});

export const { setPropertyDetails, cleartPropertyDetails, setShowFileUploadNotes, setPropertySummary } =
  propertyDetailsSlice.actions;

export default propertyDetailsSlice.reducer;
